<template>
  <v-container ma-0 pa-0>
    <v-layout row>
      <v-tooltip bottom v-for="action in actions" :key="action.value" style="margin: 0px;">
        <template slot="activator">
          <v-btn icon flat :color="action.color" @click="bus.$emit(action.event,props.item)"
            style="margin: 0px;width: 24px;height: 24px;">
            <v-icon style="margin: 0px;" small>{{action.icon}}</v-icon>
          </v-btn>
        </template>
        <span>{{action.text}}</span>
      </v-tooltip>
    </v-layout>
  </v-container>

</template>

<style scoped>

</style>

<script>
  import ActionsCell from "./actionsCell.ts";
  export default ActionsCell;
</script>